import { Form, FormTheme } from '@kanda-libs/ks-component-ts';

import { Cache } from 'components';

import AddressesInformationFields from './AddressesInformationField';
import BankInformationFields from './BankInformationFields';
import ContactInformationFields from './ContactInformationFields';
import EmploymentInformationFields from './EmploymentInformationFields';
import FinancialInformationFields from './FinancialInformationFields';
import FormLoader from './FormLoader';
import PersonalInformationFields from './PersonalInformationFields';
import Sucecss from './Success';
import useApplyYourInfoForm from './useApplyYourInfoForm';

import ApplyCard from '../components/Card';

const ApplyYourInfo: React.FunctionComponent = function () {
  const {
    form,
    onSubmit,
    cacheKey,
    showForm,
    isSubmitting,
    success,
    showButton,
    id,
  } = useApplyYourInfoForm();
  if (!cacheKey || !showForm) return <FormLoader />;
  if (success) return <Sucecss showButton={showButton} id={id} />;
  return (
    <Form form={form} id="apply-your-info" onSubmit={onSubmit}>
      <Cache cacheKey={cacheKey}>
        <FormTheme variant="streamline">
          <div className="flex flex-col gap-y-6">
            <ApplyCard noBottomPadding>
              <h1 className="text-18-22-em text-neutral-900 mb-3">
                Please provide your information
              </h1>
              <PersonalInformationFields />
            </ApplyCard>
            <ApplyCard noBottomPadding>
              <ContactInformationFields />
            </ApplyCard>
            <ApplyCard noBottomPadding>
              <AddressesInformationFields />
            </ApplyCard>
            <ApplyCard noBottomPadding>
              <EmploymentInformationFields />
            </ApplyCard>
            <ApplyCard noBottomPadding>
              <FinancialInformationFields />
            </ApplyCard>
            <ApplyCard noBottomPadding>
              <BankInformationFields isSubmitting={isSubmitting} />
            </ApplyCard>
          </div>
        </FormTheme>
      </Cache>
    </Form>
  );
};

export default ApplyYourInfo;
